import { Validators } from "../../../../common/util/Validators";

export const validatePasswordSignInForm = (value: string): Error | undefined => {
  if (!Validators.required(value)) {
    return new Error("Please enter your password");
  }
};
